import { Control, FieldPath, FieldValues } from 'react-hook-form'

import { RadioGroup, RadioGroupItem } from '../radioGroup'

import { FormControl, FormField, FormItem, FormLabel } from '.'

interface FormComplexRadioProps<T extends FieldValues> {
    control: Control<T>
    name: FieldPath<T>
    options: { value: string; label: string; description: string }[]
    className?: string
}

export default function FormComplexRadio<T extends FieldValues>({
    control,
    name,
    options,
    className,
}: FormComplexRadioProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormControl>
                        <RadioGroup
                            onValueChange={field.onChange}
                            defaultValue={field.value}
                            className="grid grid-cols-2 gap-4"
                        >
                            {options.map(option => (
                                <div
                                    key={option.value}
                                    onClick={() => field.onChange(option.value)}
                                    className={`flex cursor-pointer items-start rounded-xl border-4 bg-background p-4 hover:border-primary ${
                                        field.value === option.value ? 'border-primary' : 'border-transparent'
                                    }`}
                                >
                                    <div className="flex h-6 items-center">
                                        <FormControl>
                                            <RadioGroupItem
                                                value={option.value}
                                                id={`${name}-${option.value}`}
                                                className="mr-4"
                                            />
                                        </FormControl>
                                    </div>
                                    <FormLabel htmlFor={`${name}-${option.value}`}>
                                        <div className="cursor-pointer">
                                            <h4 className="mb-2 mt-1">{option.label}</h4>
                                            <p className="text-xs font-thin">{option.description}</p>
                                        </div>
                                    </FormLabel>
                                </div>
                            ))}
                        </RadioGroup>
                    </FormControl>
                </FormItem>
            )}
        />
    )
}
